import { FC, useState, useEffect } from 'react'
import { useSelector } from 'react-redux'

import { KTSVG, toAbsoluteUrl } from '../../../../_metronic/helpers'
import { RightAeroIcon } from '../../../../svg/RightAeroIcon'
import { LoanCompleteIcon } from '../../../../svg/LoanCompleteIcon'
import { UploadIcon } from '../../../../svg/UploadIcon'
import { UploadDataIcon } from '../../../../svg/UploadDataIcon'
import { VerifyIcon } from '../../../../svg/VerifyIcon'
import { SubmitIcon } from '../../../../svg/SubmitIcon'
import { LoanError } from '../../../../svg/LoanError'
// import { industryOptions } from "./Step1Sub3";
const Step1Sub4: FC<any> = ({ submitLoanComplete, backToLoanEligibility, updateApplication }) => {
  // const [emi, setEmi] = useState<any>(0);
  // const [interest, setInterest] = useState<any>(0);
  const [debtRatio, setDebtRatio] = useState<any>(0)
  const [timeInBusiness, setTimeInBusiness] = useState<any>(0)

  const loanApplication = useSelector((state: any) => state.loan.loanApplication)
  const loanEligibility = useSelector((state: any) => state.loan.loanEligibility)

  useEffect(() => {
    if (loanApplication && loanEligibility) {
      const {
        // industryType,
        profit,
        totalMonthlyInstallmentsToBanks,
        totalMonthlyInstallmentsToNonBanks,
        totalRevolvingCreditOutstandingToBanks,
        totalRevolvingCreditOutstandingToNonBanks,
        dateOfIncorporation,
      } = loanEligibility

      /* const incomeMargin = 0.1; // 10%in percentange
      const existingDebt = totalMonthlyInstallmentsToBanks + totalMonthlyInstallmentsToNonBanks + totalRevolvingCreditOutstandingToBanks * 0.05 + totalRevolvingCreditOutstandingToNonBanks  * 0.05 ;
      const principal = amountRequested;
      const actualIntrestRate = Number(industryOptions.find((o:any) => o.value === industryType)?.pricing);

      // Monthly interest rate : Divide by 100 to convert to fraction
      const interestRate = actualIntrestRate/1200 ; 
      const tenure = durationInMonths
      //EMI = P × r × (1 + r) n/ ((1 + r) n - 1) where P= Loan amount, r= interest rate, n=tenure in number of months
      const top = Math.pow((1+interestRate), tenure); 
      const bottom = top-1;
      const ratio = top/bottom
      const emi = principal * interestRate * ratio; */

      // Monthly Net Operating Income
      const existingDebt =
        totalMonthlyInstallmentsToBanks +
        totalMonthlyInstallmentsToNonBanks +
        totalRevolvingCreditOutstandingToBanks * 0.05 +
        totalRevolvingCreditOutstandingToNonBanks * 0.05
      const netOperatingIncome = profit / 12
      const totalDebts = existingDebt + loanApplication.emi
      const debtRatio = (totalDebts / netOperatingIncome) * 100

      // setInterest(loanApplication.interestRate);
      // setEmi(loanApplication.emi);
      setDebtRatio(debtRatio)
      const diffYear = Math.ceil(
        (new Date().getTime() - new Date(dateOfIncorporation).getTime()) /
          (1000 * 365 * 60 * 60 * 24)
      )
      setTimeInBusiness(diffYear)

      console.log('debtRatio: ' + debtRatio)
      console.log(diffYear)
    }
  }, [loanApplication, loanEligibility])

  return (
    <div className='d-flex flex-column'>
      <div className='congratulationsPage'>
        <div className='banner mt-0'>
          <div className='graphic'>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='334'
              height='208'
              viewBox='0 0 334 208'
              fill='none'
            >
              <path
                d='M0.179199 243.732L8.7793 246.843C71.0451 269.364 134.646 216.839 124.301 151.438L122.815 142.04C113.092 80.5676 173.128 31.3549 231.497 52.9515L251.91 60.5041C294.142 76.13 339.241 45.6761 340.526 0.664062M6.49317 248.798L15.0933 251.909C77.359 274.43 140.96 221.905 130.615 156.505L129.129 147.106C119.406 85.634 179.442 36.4213 237.811 58.0179L258.224 65.5705C300.456 81.1964 345.555 50.7425 346.84 5.73046M12.8075 253.872L21.4076 256.983C83.6733 279.504 147.274 226.979 136.929 161.579L135.443 152.18C125.72 90.708 185.757 41.4954 244.126 63.0919L264.538 70.6446C306.771 86.2705 351.869 55.8165 353.154 10.8045M19.1215 258.943L27.7216 262.053C89.9873 284.574 153.588 232.05 143.243 166.649L141.757 157.25C132.034 95.7783 192.071 46.5656 250.44 68.1622L270.852 75.7148C313.085 91.3407 358.183 60.8867 359.468 15.8748M25.4312 264.013L34.0313 267.124C96.297 289.645 159.898 237.12 149.553 171.72L148.067 162.321C138.344 100.849 198.38 51.6362 256.749 73.2327L277.162 80.7854C319.394 96.4113 364.493 65.9573 365.778 20.9453M31.7451 269.087L40.3452 272.198C102.611 294.719 166.211 242.194 155.867 176.794L154.381 167.395C144.658 105.923 204.694 56.7104 263.063 78.3069L283.476 85.8596C325.708 101.486 370.807 71.0315 372.092 26.0195M38.0591 274.158L46.6592 277.268C108.925 299.789 172.525 247.265 162.181 181.864L160.694 172.465C150.971 110.993 211.008 61.7807 269.377 83.3772L289.79 90.9299C332.022 106.556 377.121 76.1018 378.406 31.0898M44.3735 279.224L52.9736 282.335C115.239 304.856 178.84 252.331 168.496 186.931L167.009 177.532C157.286 116.06 217.323 66.8471 275.692 88.4436L296.104 95.9963C338.337 111.622 383.435 81.1682 384.72 36.1562M50.6875 284.294L59.2876 287.405C121.553 309.926 185.154 257.401 174.81 192.001L173.323 182.602C163.6 121.13 223.637 71.9174 282.006 93.514L302.418 101.067C344.651 116.693 389.749 86.2385 391.034 41.2266M56.9971 289.369L65.5972 292.479C127.863 315 191.463 262.476 181.119 197.075L179.632 187.676C169.909 126.204 229.946 76.9916 288.315 98.5882L308.728 106.141C350.96 121.767 396.059 91.3128 397.344 46.3008M63.311 294.443L71.9111 297.553C134.177 320.074 197.777 267.55 187.433 202.149L185.946 192.751C176.223 131.278 236.26 82.0659 294.629 103.662L315.042 111.215C357.274 126.841 402.373 96.387 403.658 51.375M69.6255 299.513L78.2256 302.624C140.491 325.145 204.092 272.62 193.747 207.22L192.261 197.821C182.538 136.349 242.575 87.1362 300.944 108.733L321.356 116.285C363.589 131.911 408.687 101.457 409.972 56.4453M75.9394 304.587L84.5396 307.698C146.805 330.219 210.406 277.694 200.061 212.294L198.575 202.895C188.852 141.423 248.889 92.2104 307.258 113.807L327.67 121.36C369.903 136.986 415.001 106.532 416.286 61.5195M82.2534 309.658L90.8535 312.768C153.119 335.289 216.72 282.765 206.375 217.364L204.889 207.965C195.166 146.493 255.203 97.2807 313.572 118.877L333.984 126.43C376.217 142.056 421.315 111.602 422.6 66.5898M88.5679 314.724L97.168 317.835C159.434 340.356 223.034 287.831 212.69 222.431L211.203 213.032C201.48 151.56 261.517 102.347 319.886 123.944L340.299 131.496C382.531 147.122 427.629 116.668 428.914 71.6562M94.8955 319.709L103.496 322.819C165.761 345.34 229.362 292.815 219.018 227.415L217.531 218.016C207.808 156.544 267.845 107.331 326.214 128.928L346.626 136.481C388.859 152.107 433.957 121.653 435.242 76.6406M101.224 324.673L109.824 327.784C172.089 350.305 235.69 297.78 225.346 232.38L223.859 222.981C214.136 161.509 274.173 112.296 332.542 133.893L352.954 141.446C395.187 157.071 440.285 126.617 441.57 81.6055M107.547 329.65L116.147 332.76C178.413 355.281 242.013 302.757 231.669 237.356L230.182 227.957C220.459 166.485 280.496 117.273 338.865 138.869L359.278 146.422C401.51 162.048 446.609 131.594 447.894 86.5818M113.88 334.626L122.48 337.737C184.745 360.258 248.346 307.733 238.002 242.333L236.515 232.934C226.792 171.462 286.829 122.249 345.198 143.846L365.61 151.398C407.843 167.024 452.941 136.57 454.226 91.5583M120.203 339.611L128.803 342.721C191.069 365.242 254.669 312.718 244.325 247.317L242.838 237.918C233.115 176.446 293.152 127.234 351.521 148.83L371.934 156.383C414.166 172.009 459.264 141.555 460.549 96.5427M126.531 344.587L135.131 347.698C197.397 370.219 260.997 317.694 250.653 252.294L249.166 242.895C239.443 181.423 299.48 132.21 357.849 153.807L378.262 161.359C420.494 176.985 465.592 146.531 466.877 101.519M132.859 349.56L141.459 352.67C203.724 375.191 267.325 322.667 256.981 257.266L255.494 247.868C245.771 186.395 305.808 137.183 364.177 158.779L384.589 166.332C426.822 181.958 471.92 151.504 473.205 106.492M139.187 354.533L147.787 357.643C210.052 380.164 273.653 327.639 263.309 262.239L261.822 252.84C252.099 191.368 312.136 142.155 370.505 163.752L390.917 171.305C433.15 186.931 478.248 156.477 479.533 111.465M145.515 359.513L154.115 362.624C216.381 385.145 279.981 332.62 269.637 267.219L268.15 257.821C258.427 196.349 318.464 147.136 376.833 168.732L397.246 176.285C439.478 191.911 484.576 161.457 485.861 116.445M151.842 364.497L160.443 367.608C222.708 390.129 286.309 337.604 275.964 272.204L274.478 262.805C264.755 201.333 324.792 152.12 383.161 173.717L403.573 181.27C445.806 196.895 490.904 166.441 492.189 121.429M158.175 369.47L166.775 372.581C229.041 395.102 292.641 342.577 282.297 277.177L280.81 267.778C271.087 206.306 331.124 157.093 389.493 178.69L409.906 186.242C452.138 201.868 497.236 171.414 498.521 126.402M164.498 374.443L173.098 377.553C235.364 400.074 298.965 347.55 288.62 282.149L287.134 272.75C277.411 211.278 337.447 162.066 395.816 183.662L416.229 191.215C458.461 206.841 503.56 176.387 504.845 131.375M170.826 379.419L179.426 382.53C241.692 405.051 305.293 352.526 294.948 287.126L293.462 277.727C283.739 216.255 343.775 167.042 402.145 188.639L422.557 196.191C464.789 211.817 509.888 181.363 511.173 136.351M177.159 384.396L185.759 387.506C248.025 410.027 311.625 357.503 301.281 292.102L299.794 282.703C290.071 221.231 350.108 172.019 408.477 193.615L428.89 201.168C471.122 216.794 516.22 186.34 517.505 141.328'
                stroke='var(--primary-color)'
                stroke-width='0.884253'
              />
            </svg>
          </div>
          {debtRatio <= 85 && timeInBusiness > 2 ? <LoanCompleteIcon /> : <LoanError />}

          <div>
            <h3>{debtRatio <= 85 && timeInBusiness > 2 ? 'Congratulations' : 'Sorry'}</h3>
          </div>
          <p>
            {debtRatio <= 85 && timeInBusiness > 2 && (
              <div className='sub-heading mb-10 fs-3'>
                {`Hi  `}
                <strong>{loanApplication?.applicantName || 'Applicant Name'}</strong>
                {`. We are excited to inform you that `}
                <strong>{loanEligibility?.companyName || 'Company name'}</strong>
                {` maybe eligible for a loan amount of upto  `}
                <strong>
                  {` SG$  `}

                  {loanApplication
                    ? loanApplication.amountRequested
                        .toString()
                        .replace(/(\d)(?=(\d{3})+(\.(\d){0,2})*$)/g, '$1,')
                    : 'XX,XXX,XXX'}
                </strong>
                {` based on the declarations.`}
              </div>
            )}

            {!(debtRatio <= 85 && timeInBusiness > 2) && (
              <div className='sub-heading mb-10 fs-5'>
                {`Hi `}
                <strong>{loanApplication?.applicantName}</strong>
                {`, We are sorry to inform that "`}
                <strong>{loanEligibility?.companyName}</strong>
                {`" may not be eligible for a business loan as it does not fit minimum eligibility rules based on the declarations. 
    For any queries please feel free to email us at `}
                <a href='mailto:loans@credilinq.ai'>
                  <strong>loans@credilinq.ai</strong>
                </a>
                {` with the application reference.`}
              </div>
            )}
          </p>
        </div>
        <div className='notice d-flex banner text-start p-6 mb-5 mt-5'>
          <div className='d-flex flex-stack flex-grow-1'>
            <div>
              <h4 className='text-primary fs-2'>Business Loan's Tip</h4>
              <hr className='text-gray-400' />
              <div className='fs-3'>
                We want you to complete the application submission in a flash and Business Loan
                Application recommends that you prepare few documents ready before you proceed
              </div>
            </div>
          </div>
        </div>
        <div className='stepSection cardNew'>
          <h3>You are just 3 more steps away from your submission of loan application</h3>
          <div className='stepBoxes'>
            <div className='stepBoxWrap'>
              <div className='stepBox'>
                <UploadDataIcon fontSize={40} color='currentColor' />
                <h2 className='mt-4'>Upload</h2>
                <ul>
                  <li>Bank Statements</li>
                  <li>Financial Statements</li>
                </ul>
              </div>
            </div>
            <div className='stepBoxWrap'>
              <div className='stepBox'>
                <VerifyIcon fontSize={40} color='currentColor' />
                <h2 className='mt-4'>Verify</h2>
                <ul>
                  <li>Company via Myinfo business</li>
                  <li>Guarantor via Singpass Myinfo</li>
                </ul>
              </div>
            </div>
            <div className='stepBoxWrap'>
              <div className='stepBox'>
                <SubmitIcon fontSize={40} color='currentColor' />
                <h2 className='mt-4'>Submit</h2>
                <ul>
                  <li>Review the Application</li>
                  <li>Review the Documents</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='cardNew stickeyFooter'>
        <div className='d-flex justify-content-between'>
          <button className='button button-outline-primary' onClick={() => backToLoanEligibility()}>
            Recheck Eligibility
          </button>
          {debtRatio <= 85 && timeInBusiness > 2 && (
            <button
              type='submit'
              className='button button-primary'
              onClick={() => submitLoanComplete()}
            >
              Save and Continue <RightAeroIcon color='currentColor' />
            </button>
          )}
        </div>
      </div>
    </div>
  )
}

export { Step1Sub4 }
